<template>
  <div>
    <p :class="{mandatory:isMandatory}">{{ question }}</p>
    <b-field :label="uploadedText" v-if="existingValue" >
      <a :href="existingValue">{{displayValue}}</a>
    </b-field>
    <b-field class="personalise">
      <b-tooltip :label="tooltip" position="is-bottom" type="is-light">
        <b-upload v-model="file" drag-drop accept=".doc,.docx,.pdf,.png,.jpeg,.jpg,.rtf" :tabIndex="tab"
                  :disabled="isDisabled" @input="handleFileUpload" >
          <div class="section">
            <div class="content has-text-centered">
              <p>
                <b-icon icon="upload" size="is-large"></b-icon>
              </p>
              <p>Drop your file here or click to upload</p>
              <p class="not-important"> Accepted file formats:</p>
              <p class="not-important">.doc,.docx,.pdf,.png,.jpeg,.jpg,.rtf</p>
            </div>
          </div>
        </b-upload>
      </b-tooltip>
    </b-field>
    <div class="tags">
      <span class="tag is-primary" v-if="file">
        {{truncateLongFileName(file.name)}}
        <button class="delete is-small no-padding" type="button" @click="deleteFile()"></button>
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    question: String,
    isDisabled: Boolean,
    tooltip: String,
    isMandatory: Boolean,
    uploadedText: String,
    isMobile: Boolean,
    existingValue: { type: String, default: '' },
    tab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      file: null,
    };
  },
  methods: {
    deleteFile() {
      this.file = '';
      this.$emit('file-deleted');
    },
    handleFileUpload() {
      this.$emit('file-uploaded', this.file);
    },
    /**
     * @param {String} file the name of the file uploaded
     */
    truncateLongFileName(file) {
      return file.length > 20 && this.isMobile ? `${file.substr(0, 20)}...${file.substr(-3, 3)}` : file;
    },
  },
  computed: {
    displayValue() {
      return this.existingValue ? this.existingValue.split('/').pop() : '';
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '../styles/_mixins.scss';
  .no-padding {
    padding-right: 0;
  }
  .personalise div.section .not-important {
    font-size: 9.5px;
    margin-top: 0px;
    margin-bottom: 0px;
    @include DefaultPoppinFont();
  }

</style>
